import { withErrorBoundary, Formatter } from 'shared'
import { SmartButtonStub } from 'ui/smart-buttons'
import { LogoImage } from 'customizations'
import { User } from 'api'
import { useEffect, useState } from 'react'

const MarketplaceSignupPage = () => {
  const [state, setState] = useState({
    user: { email: '', phone: '', first_name: '', last_name: '', password: '', passwordConfirmation: '' }
  });

  useEffect(() => {
    loadData();
    parseUTM();
    if (User.signedIn && User.regular) App.signOut({ redirectPath: '/app/marketplace-signup' });
  }, []);

  const inputChanged = (e) => {
    const { name, value } = e.target;
    setState({
      ...state,
      user: { ...state.user, [name]: value },
      errors: null
    });
  };

  const loadData = async () => {
    const settings = await Backend.get('/users/marketplace_signup_links');
    setState({ ...state, settings });
  };

  const parseUTM = () => {
    const params = application.queryParams;
    if (params?.has('utm_source')) {
      state.user.utm_source = params.get('utm_source');
      setState({ ...state, user: { ...state.user } });
    }
    if (params?.has('retail_id')) {
      setState({ ...state, retail_id: params.get('retail_id') });
    }
  };

  const submit = async (e) => {
    e.preventDefault();
    setState({ ...state, submitting: true });
    try {
      const res = await Backend.post('/users/create_marketplace_signup', { user: state.user, retail_id: state.retail_id });
      User.signIn(res.user);
      setState({ ...state, errors: null, success: true });
      window.location = '/app';
    } catch (xhr) {
      if (xhr.status >= 400 && xhr.status <= 499) {
        console.log(xhr)
        setState({ ...state, errors: xhr.responseJSON.errors });
      }
    } finally {
      setState({ ...state, submitting: false });
    }
  };

  const renderForm = () => {
    const settings = state.settings || {};
    return (
      <form className="signup--form" onSubmit={submit}>
        <p dangerouslySetInnerHTML={{ __html: Formatter.simpleFormat(settings.welcome_text) }}></p>
        {state.errors && state.errors.map((error) => <p key={error} className="alert alert-danger alert-mini text-center">{error}</p>)}
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="signup--first-name">First Name</label>
              <input type="text" className="form-control" id="signup--first-name" name="first_name" value={state.first_name} onChange={inputChanged} />
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="signup--last-name">Last Name</label>
              <input type="text" className="form-control" id="signup--last-name" name="last_name" value={state.last_name} onChange={inputChanged} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="signup--email">Email Address</label>
              <input type="email" className="form-control" id="signup--email" name="email" value={state.email} onChange={inputChanged} />
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="signup--phone">Phone Number</label>
              <input type="tel" className="form-control" id="signup--phone" name="phone" value={state.phone} onChange={inputChanged} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <div className="form-group">
              <label htmlFor="signup--password">Password</label>
              <input type="password" className="form-control" id="signup--password" name="password" value={state.password} onChange={inputChanged} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <div className="form-group">
              <label htmlFor="signup--passwordConfirmation">Confirm Password</label>
              <input type="password" className="form-control" id="signup--passwordConfirmation" name="confirm_password" value={state.passwordConfirmation} onChange={inputChanged} />
            </div>
          </div>
        </div>
        <div className="form-actions text-center">
          <SmartButtonStub text="Sign Up" buttonType="submit" className="inverted primary" spinning={state.submitting} />
        </div>
      </form>
    );
  };

  const renderSuccess = () => <p className="alert alert-success text-center">Thank you for registering!</p>;

  const settings = state.settings || {};
  const pageTitle = settings.page_title;
  const backgroundColor = settings.color || '#ccc';
  const headImage = settings.head_image_url;
  const asideImage1 = settings.aside_image_1_url;
  const asideImage2 = settings.aside_image_2_url;

  return (
    <div className="Login Signup">
      <div className="left d-none d-sm-block">
        <div className="left-overlay"></div>
        <p className="login-copyright">{application.assets.get('copyright')}</p>
      </div>
      <div className="right">
        <img src={LogoImage} className="logo-image mb-2" />
        <section className="form">
          <h3 className="mb-3 d-none">Sign Up</h3>
          {state.success ? renderSuccess() : renderForm()}
          {!App.isBigSky && (
            <p className="links text-center my-2">
              <Link to="login" className="smart-button btn inverted primary">
                <span className="smart-button-text">Return to Sign In</span>
              </Link>
            </p>
          )}
        </section>
      </div>
    </div>
  );
};

export default withErrorBoundary(MarketplaceSignupPage);
